<template>
    <div class="main-body">
        <div class="header">长者端APP轮播图</div>
        <div class="out">

          <div class="search">
            <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
          </div>

          <div style="height: 10px;"></div>

          <el-table class="table" v-loading="tableLoading" :data="tableData" :height="th" border>
              <el-table-column prop="imgPath" label="图标">
                  <template slot-scope="scope">
                      <el-popover placement="right" title="" trigger="click">
                          <img :src="imgUrl+scope.row.imgPath"  style="width: 500px"/>
                          <img slot="reference" :src="imgUrl+scope.row.imgPath" style="width:50px">
                      </el-popover>
                  </template>
              </el-table-column>
              <el-table-column prop="sort" label="排序"></el-table-column>
              <el-table-column fixed="right" label="操作" width="200" align='center'>
                  <template slot-scope="scope">
                      <el-button type="success" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
              </el-table-column>
          </el-table>

          <div class="page">
                <div style="float: left;padding: 5px;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
                <div style="float: left;">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalItems"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"  @current-change="current_change">
                </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:attributeList="attributeList" v-on:closeAdd="closeAdd"  v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:attributeList="attributeList" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5_with_china} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Edit from "./Edit";
    import Add from "./Add";


    export default {
        name: "Role",
        data(){
            return{
                tableLoading:false,

                showModalAdd:false,
                showModalEdit:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,

                imgUrl:this.$imgUrl,

            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.init()

            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
              this.getList();
            },

            handleDelete(index, row) {
              this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.deleteDo(row);
              }).catch(e=>e)
            },


            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },

            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            deleteDo(row){
                let data={
                    timeStr:timeStr,
                    sign:'',
                  appBannerElderlyCode:row.appBannerElderlyCode,
                }

              data.sign = "";
              data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)

              this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppBannerElderly/Delete",
                    data: data
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.getList();
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


            getList(){

              var _this=this

              this.tableLoading=true

              var data={
                  timeStr: timeStr,
                  sign: '',
                  staffCode: getStaffCode(),
              }

              data.sign = "";
              data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


              this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppBannerElderly/List",
                    data: data
                }).then( (response)=> {
                  _this.tableLoading = false;
                  if(response.data.error == 0){
                    this.tableData = response.data.data.list;
                  }else if(response.data.error == 1){
                      this.$message.error(response.data.message)
                  }

                }).catch(function (error) {
                  _this.tableLoading = false;
                  console.log(error)
                });
            },



        }
    }
</script>

